import React, { useState, useRef, useEffect } from 'react';
import '../styling/SignUp.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import BookingHeader from './clientPortal/BookingHeader';

const VerificationCode = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // --- New logic to handle userType ---
  // Get email and userType from the previous page's state
  const email = location.state?.email;
  // Default to 'business' for safety, but warn if not provided
  const userType = location.state?.userType || 'business';

  if (location.state?.userType) {
    console.warn("VerificationCode: userType not provided in location.state. Defaulting to 'business'.");
  }

  // API endpoints based on userType
  const apiConfig = {
    business: {
      verify: `${process.env.REACT_APP_API_URL}/business-user/verify-code`,
      resend: `${process.env.REACT_APP_API_URL}/business-user/forgot-password`
    },
    client: {
      verify: `${process.env.REACT_APP_API_URL}/client-user/verify-client-code`,
      resend: `${process.env.REACT_APP_API_URL}/client-user/forgot-client-password`
    }
  };

  const currentApi = apiConfig[userType];
  // --- End of new userType logic ---


  const [code, setCode] = useState(new Array(6).fill(''));
  const inputsRef = useRef([]);

  // --- New state for resend logic ---
  const [isResending, setIsResending] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [notification, setNotification] = useState('');
  // ---

  // Start countdown timer
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);


  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ''); // Only allow numbers
    if (value) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      // Focus next input
      if (index < 5 && inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newCode = [...code];

      if (code[index]) {
        // If there's something in the current box, just clear it
        newCode[index] = '';
        setCode(newCode);
      } else if (index > 0) {
        // If empty, move to the previous box and clear it
        newCode[index - 1] = '';
        setCode(newCode);
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = async () => {
    const token = code.join('');
    if (token.length !== 6) {
      alert('Please enter the full 6-digit code.');
      return;
    }
    try {
      const res = await axios.post(currentApi.verify, { token: token }, { withCredentials: true });
      
      // --- CHANGED HERE ---
      // Extract the resetToken from the backend response
      const resetToken = res.data.data?.resetToken; 
      
      alert(res.data.data?.message || "Code verified successfully");
      
      // Pass the resetToken in the state object
      navigate('/resetPassword', { 
        state: { 
          email: email, 
          userType: userType,
          resetToken: resetToken // <--- KEY ADDITION
        } 
      });

    } catch (err) {
      alert(err.response?.data?.message || 'Invalid or expired code');
    }
  };

  // --- New Resend Code Function ---
  const handleResendCode = async () => {
    if (countdown > 0) return; // Don't resend if timer is active

    setIsResending(true);
    setNotification('');
    try {
      // Call the correct "forgot password" endpoint, which acts as our resend endpoint
      await axios.post(currentApi.resend, { email });
      setNotification('A new code has been sent.');
      setCountdown(60); // Start 60-second cooldown
    } catch (err) {
      setNotification(err.response?.data?.message || 'Failed to send new code.');
    } finally {
      setIsResending(false);
    }
  };
  // ---

  return (
    // Increased height to fit new elements
    <div>
    <BookingHeader/>
    <div className="login" style={{ marginTop: '10px', height: 'auto', minHeight: '380px' }}>
      <div style={{ padding: '8%' }}>
        <div
          style={{
            fontSize: '20px',
            color: '#1C1154',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          Check your email
        </div>

        <div style={{ color: '#625C73', textAlign: 'center' }}>
          <p>Please enter the verification code we sent to <b>{email}</b></p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '20px' }}>
          {code.map((digit, idx) => (
            <input
              key={idx}
              type="text"
              inputMode="numeric" // Better for mobile
              pattern="[0-9]*"
              maxLength="1"
              value={digit}
              ref={(el) => (inputsRef.current[idx] = el)}
              onChange={(e) => handleChange(e.target, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              style={{
                width: '35px',
                height: '35px',
                textAlign: 'center',
                fontSize: '18px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            />
          ))}
        </div>

        <button className="login-button" onClick={handleSubmit}>
          Verify Code
        </button>

        {/* --- New Resend Button Logic --- */}
        <div style={{ textAlign: 'center', marginTop: '15px' }}>
          {notification && <p style={{ color: '#1C1154', fontSize: '14px' }}>{notification}</p>}
          <button
            onClick={handleResendCode}
            disabled={countdown > 0 || isResending}
            style={{
              background: 'none',
              border: 'none',
              color: (countdown > 0 || isResending) ? '#999' : '#1C1154',
              textDecoration: 'underline',
              cursor: (countdown > 0 || isResending) ? 'not-allowed' : 'pointer',
              fontSize: '14px',
            }}
          >
            {isResending
              ? 'Sending...'
              : countdown > 0
              ? `Resend code in ${countdown}s`
              : 'Didn\'t receive the code? Resend'}
          </button>
        </div>
        {/* --- End Resend Button Logic --- */}


        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
          <p style={{ color: '#545454', textAlign: 'center' }}>
            Go Back to <Link to="/login"><span style={{ textDecoration: 'underline', cursor: 'pointer' }}>login page</span></Link>
          </p>
        </div>

      </div>
    </div>
    </div>
  );
};

export default VerificationCode;